export enum DesifVersaoEnum {

  V_2_2 = "2.2",
  V_2_3 = "2.3",
  V_3_1 = "3.1",
  V_3_2 = "3.2"
}
